import React from "react";
import App from "../../app/App";
import RegisterContainer from "./RegisterContainer";

export default () => (
  <App>
    <RegisterContainer />
  </App>
);
